import { cdnImageUrl } from 'helpers/image'
import { useObserver } from 'mobx-react-lite'
import {
  ContentBannerSection,
  ContentSectionButton,
  ContentSectionButtonsHolder,
  ContentSectionCtaHolder,
  ContentSectionHeaderWide,
  ContentSectionOverlay,
  ContentSectionSubHeaderWide,
  TeaserBackground,
} from 'pages/Welcome/components/WelcomePageContentFocus/content/content-styles'
import { useCategoryLinks } from 'pages/Welcome/hooks/use-category-links'
import React, { FC } from 'react'
import { useService } from 'services/utils/context'
import { WelcomePageBlock } from 'store/features/config'

export const ContentGenderSelectBanner: FC<WelcomePageBlock> = ({
  headline,
  subline,
  imagelink,
}) => {
  const service = useService()

  const genderSelectTile = useObserver(() =>
    service.staticImages.getById('welcomepage_genderselect_all_teaser'),
  )

  const categoryLinks = useCategoryLinks()

  return (
    <ContentBannerSection
      isWide
      noImage={!genderSelectTile?.hash}
      data-testid="ContentGenderSelectBanner"
    >
      <TeaserBackground
        src={cdnImageUrl(imagelink || '', {
          width: 1500,
        })}
        alt={genderSelectTile?.alt || ''}
        height={100}
        width={100}
      />
      <ContentSectionOverlay>
        <ContentSectionCtaHolder>
          <ContentSectionHeaderWide>{headline}</ContentSectionHeaderWide>
          <ContentSectionSubHeaderWide>{subline}</ContentSectionSubHeaderWide>
          <ContentSectionButtonsHolder>
            {categoryLinks.map((categoryLink, i) => (
              <ContentSectionButton
                key={`${categoryLink.title}-${i}`}
                data-testid="Link"
                href={categoryLink.link}
              >
                {categoryLink.title}
              </ContentSectionButton>
            ))}
          </ContentSectionButtonsHolder>
        </ContentSectionCtaHolder>
      </ContentSectionOverlay>
    </ContentBannerSection>
  )
}
